import { AT } from '../../../actions/actionTypes';
import { doAction } from '../../../core/redux/store';
import { setRightPanel } from '../actions';
import { Panels } from '../model';
import { View } from './model';
import { TransferActivitiesTabDialogMap, TransferDialogs } from './consts';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

export const openTransferDialog = () => {
  Logger.info(['openTransferDialog'], LogArea.Redux);
  setRightPanel(Panels.DEVICE_TRANSFER);
};

export const onTabChange = (tabId: string) => {
  Logger.info(['new tab selected', tabId], LogArea.Redux);
  const screen: TransferDialogs = TransferActivitiesTabDialogMap[tabId];
  changeScreen(screen);
};

export const changeScreen = (screen: TransferDialogs) => {
  const payload: View = { screen };
  doAction<View>(AT.DIALOG_TRANSFER_SETMODE, payload);
  openTransferDialog();
};
